import React, { useState } from "react";
import Donation from "./Donation/Donation";
import BiddingPanel from "./BiddingPanel/BiddingPanel";
import GiftCard from "./GiftCard/GiftCards/GiftCard";

const RedeemMethodsUrlTab = () => {
  const [activeComponent, setActiveComponent] = useState("Donation");
  // Array with tab names and corresponding components
  const tabs = [
    { name: "Donation", component: <Donation /> },
    { name: "Lucky Draw", component: <BiddingPanel /> },
    { name: "Gift Cards", component: <GiftCard /> },
  ];

  // Find the active tab and its component
  const renderComponent = () => {
    const activeTab = tabs.find(tab => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };

  const changeActiveComponent = (name) => {
    setActiveComponent(name)
  }

  return (
    <div className="min-h-screen flex flex-col items-center p-6 pt-1">
        <div className="flex space-x-2 mb-6 max-w-100 flex-wrap gap-2">
          {tabs.map(({ name }) => (
            <button
              key={name}
              className={`px-3 py-2 rounded-lg text-sm border-b-2 ${activeComponent === name
                  ? "activeBtn text-white"
                  : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
                }`}
              onClick={() => { changeActiveComponent(name) }}
            >
              {name}
            </button>
          ))}
      </div>
      
      {renderComponent()}
    </div>
  );
};

export default RedeemMethodsUrlTab;
